import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Learn from './pages/Learn.jsx';
import Practice from './pages/Practice.jsx';
import Tests from './pages/Tests.jsx';
import Progress from './pages/Progress.jsx';
import Settings from './pages/Settings.jsx';
import Auth from './pages/Auth.jsx';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts.js';
export default function App() {
  const { user, loading, configured } = useAuth();
  const navigate = useNavigate();
  useKeyboardShortcuts(useMemo(() => ({ 'mod+k': () => navigate('/learn'), 'mod+j': () => navigate('/practice') }), [navigate]));
  if (loading) return <div className="center-screen">Loading your prep room...</div>;
  if (configured && !user) return <Auth />;
  return <Routes><Route element={<Layout />}><Route index element={<Dashboard />} /><Route path="learn" element={<Learn />} /><Route path="practice" element={<Practice />} /><Route path="tests" element={<Tests />} /><Route path="progress" element={<Progress />} /><Route path="settings" element={<Settings />} /><Route path="*" element={<Navigate to="/" replace />} /></Route></Routes>;
}
